
import { Navigation } from '@ts/components/Navigation';

export const init = () => {
    Navigation.create('#menu-trigger', { 
        menuContainerSelector: '.main-nav-container' 
    });
}